module.exports = __webpack_public_path__ + "img/Picture10.b65cc166.png";